import axiosInstance from "../apiConfig";

const fetchProjects = async (filters) => {
  const response = await axiosInstance.get('/project', {
    params: { 
      ...filters,
    }
  });
  return response.data;
}

const projectsApi = { fetchProjects };
export default projectsApi;